<template>
  <div class="xcard">
    <v-toolbar-title class="mb-5 py-2" style="border-bottom: 1px solid #d4dbe0">
      <span>CONFIGURACIONES GENERALES</span>
    </v-toolbar-title>

    <v-row>
      <v-col cols="12" class="pa-2 pb-0">
        <v-radio-group v-model="configuracion.visualizacion_clasificadores" row>
          <template v-slot:label>
            <h5><strong>Cuentas: </strong>seleccione los que se visualizarán en "Opciones de Presupuestos"</h5>
          </template>

          <v-radio v-for="(item, index) in opciones" :key="index" :label="item.text" :value="item.value"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" class="pa-2 pb-0">
        <v-radio-group v-model="configuracion.visualizacion_clasificadores_recursos" row>
          <template v-slot:label>
            <h5><strong>Cuentas: </strong>seleccione los que se visualizarán en "Solicitud de Recursos"</h5>
          </template>

          <v-radio v-for="(item, index) in opciones" :key="index" :label="item.text" :value="item.value"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" class="pa-2 pb-0">
        <h5>
          <strong>Estados de Detalles de Solicitudes: </strong>seleccione en los que se permitirá cambiar, subir o
          eliminar el archivo adjunto
        </h5>

        <div class="d-flex flex-wrap">
          <v-checkbox
            class="mx-2"
            v-model="configuracion.estado_permitir_operaciones_archivos_adjuntos"
            v-for="(item, index) in estados"
            :key="index"
            :label="item"
            :value="item"></v-checkbox>
        </div>
      </v-col>

      <v-col cols="12" class="pa-2 pb-4">
        <v-btn color="primary" :disabled="enviando" :loading="enviando" @click="editar">
          <v-icon>mdi-content-save</v-icon>

          Actualizar
        </v-btn>
      </v-col>
    </v-row>

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import { ESTADOS_DETALLE_SOLICITUD, formatearErrores } from '../utils';
import ConfiguracionesService from './../services/configuraciones';

export default {
  name: 'ConfiguracionesGenerales',
  data() {
    return {
      enviando: false,
      nombreRecurso: 'Configuraciones Generales',
      configuracion: {
        visualizacion_clasificadores: null,
        visualizacion_clasificadores_recursos: null,
        estado_permitir_operaciones_archivos_adjuntos: [],
      },
      opciones: [
        { text: 'Todos', value: 'Todos' },
        { text: 'Solo Anteriores', value: 'Solo Anteriores' },
        { text: 'Solo Oracle', value: 'Solo Oracle' },
      ],
      estados: Object.values(ESTADOS_DETALLE_SOLICITUD).filter((estado) => estado != ESTADOS_DETALLE_SOLICITUD.TODOS),
    };
  },
  created() {
    this.obtenerConfiguraciones();
  },
  methods: {
    async obtenerConfiguraciones() {
      try {
        const response = await ConfiguracionesService.get(1);

        this.configuracion = response.data.datos;
      } catch (error) {
        window.console.log(error);
      }
    },
    async editar() {
      this.enviando = true;

      try {
        const response = await ConfiguracionesService.update(this.configuracion.id, this.configuracion);

        this.obtenerConfiguraciones();
        this.$notify({
          group: 'notifications',
          title: this.nombreRecurso.toUpperCase(),
          text: response.data.mensaje,
          type: 'success',
        });
      } catch (error) {
        const { mensaje, errores } = error.response.data;
        const erroresFormateados = formatearErrores(errores);

        this.$notify({
          group: 'notifications',
          title: `${this.nombreRecurso}: ${mensaje}`,
          text: erroresFormateados,
          type: 'error',
        });

        window.console.log(error);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style>
</style>